export const newsletterAnchor = (function ($) {

    function init() {
        jQuery(window).on("load", function () {
            // check if contain hashtag or if converted string by instagram app exists (# -> %23)
            if (window.location.hash === "#stay-updated" || window.location.href.indexOf("%23stay-updated") > -1) {
                setTimeout(() => {
                    jQuery("html,body").animate({
                        scrollTop: jQuery("#stay-updated").offset().top,
                    }, 0);
                }, 500);
            }
        });
    }

    return {
        init: init
    }

})(jQuery);
